import { GetStaticPaths, GetStaticProps, GetStaticPropsContext } from 'next'

import { getPaths } from '@/lib/paths'
import {
  getRvdbNavigationData,
  getStoriesSlugData,
  getStoryDetailData,
} from '@/services/contentful/api'
import Main from '@/layouts/main'
import StoryBanner from '@/sections/ray/story-detail/banner'
import PageProps from '@/interfaces/page'
import { Story } from '@/interfaces/schema'
import ContentLargeSection from '@/sections/repeatable/content-large'
import RelatedArticles from '@/sections/repeatable/story-detail/related-articles'
import WithFallback from '@/lib/with-fallback'
import { getSlugs, stringifySlug } from '@/lib/slugs'
import { routes } from '@/lib/constants'

const StoryDetail = ({ data }: PageProps<Story>) => {
  const { image, title, content, relevantStoriesCollection } = data

  return (
    <Main>
      <StoryBanner image={image} />
      <ContentLargeSection
        title={title}
        content={content}
        backBtnLink={routes.rvdb.knowledgeAndInspiration}
        backBtnText="Artikel overzicht"
      />
      {relevantStoriesCollection && (
        <RelatedArticles
          relevantStoriesCollection={relevantStoriesCollection}
        />
      )}
    </Main>
  )
}

export const getStaticProps: GetStaticProps = async ({
  params,
  preview,
}: GetStaticPropsContext) => {
  const isPreview: boolean = !!preview ?? false
  const slug = stringifySlug(params)

  const { data: pageData, error: pageError } = await getStoryDetailData(
    slug,
    isPreview
  )
  const { data: navData, error: navError } = await getRvdbNavigationData(
    isPreview
  )

  if (!pageData?.items[0]?.displayOnRvdb || !pageData?.items.length)
    return { notFound: true }

  return {
    props: {
      data: { navData, pageData: pageData?.items[0] },
      error: { pageError, navError },
    },
    revalidate: 60,
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const isPreview = false
  const { data } = await getStoriesSlugData(isPreview)
  const slugs = getSlugs(data)
  const paths = getPaths(slugs)

  return {
    paths,
    fallback: 'blocking',
  }
}

export default WithFallback<Story>(StoryDetail)
